import styled from 'styled-components';

import Box from '../components/layout/Box';

const StyledBox = styled(Box)`
  flex-direction: column;
  height: auto;
  min-height: calc(100vh - 64px);
  flex-grow: 1;
  flex-shrink: 0;
`;

const MainContentContainer = ({ children }) => {
  return <StyledBox>{children}</StyledBox>;
};

export default MainContentContainer;
